// Release 1016 (blind QA round 2 + Fable review + Alvin's "Host only"). Customer words drafted by Astra (GPT-6, copy lane),
// gated by Claude against AGENTS.md (plain words, "activities", no assumed friends, placeholders kept). No hand edits.
const COPY = {
  'rl.time_suggested': 'Suggested from your saved activities. Tap to change.',
  'rl.suggested_tag': 'Suggested',
  'rl.parts_suggested': 'Suggested times: {parts}',
  'rl.clash_hours': 'This time is outside opening hours.',
  'rl.vote_explain_self': "Group members vote for activities they'd go to. You see the counts when setting the plan.",
  'rl.invite_title': 'Invite people',
  'rl.name_placeholder': 'What you go by',
  'rl.group_name_placeholder': 'Saturday together',
  'rl.email_why': "Add your email to get an invite from the host's calendar app once the plan is set.",
  'rl.email_optin': 'Share {email} with this group for calendar invites',
  'rl.voting_closed': 'Voting is closed because the plan is set.',
  'rl.host_only': 'Only {owner} can build and lock in the plan. You can vote and add ideas.',
  'rl.build_host_only_title': 'Only the host can build the plan',
  'rl.build_host_only_body': "Only {owner} can build this group's plan. You can still vote and add activities on the group page.",
  'rl.back_to_group': 'Back to group',
  'rl.locked_for': '{count} activities on {date}',
  'rl.locked_for_one': '{count} activity on {date}',
  // blind round 3 (10/15): drafted by Astra (build/astra/release-1016-r3-copy.txt), gated by Claude
  'rl.lock_only_on': 'Only on {date}',
  'rl.lock_not_that_day': 'Not on your chosen day',
  'rl.lock_hours_unknown': 'Time is an estimate. Check this place’s hours.',
  'rl.lock_offday_one': '{count} activity isn’t on your chosen day and will be left out.',
  'rl.lock_offday_other': '{count} activities aren’t on your chosen day and will be left out.',
  'rl.back_itineraries': 'Back to Itineraries',
  'rl.group_label': 'Plan for {group}',
  'rl.fr_done_early': 'Go to summary',
  'rl.err_title': 'This screen didn’t load',
  'rl.err_body': 'Reloading usually fixes this.',
  'rl.err_reload': 'Reload',
  'rl.err_browse': 'Go to Browse',
} as const

export type ReleaseKey = keyof typeof COPY
export const rl = (key: ReleaseKey, vars: Record<string, string | number> = {}): string =>
  COPY[key].replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m))
